import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {

		// 项目ID(直接配置)
		projectId: 2,

		// 项目GIS地址(直接配置)
		gisUrl: 'kaijun_web',

		// 受电容量和供电电压(在home里面通过接口获取)
		receivingCapacity: 0,
		voltageClass: 0,

		// 接线图列表(直接配置)
		distribution: [{
			id: 3,
			name: "凯骏配电房一次接线图",
			url: "http://local.vrmaker.vip:38080/wiring/KingSrichOnce.html",
		}, {
			id: 4,
			name: "A栋生产车间接线图",
			url: "http://local.vrmaker.vip:38080/wiring/AD.html",
		}, {
			id: 5,
			name: "B栋生产车间接线图",
			url: "http://local.vrmaker.vip:38080/wiring/BD.html",
		}, {
			id: 6,
			name: "C栋生产车间接线图",
			url: "http://local.vrmaker.vip:38080/wiring/CD.html",
		}, ],

		// 监控和门禁列表(直接配置)
		surveillance: [{
			areaId: 3,
			rooms: {
				types: ["监控列表", "门禁列表"],
				details: [
					[{
							name: "凯骏配电房#东#Camera01",
							roomName: "KJMain",
						},
						{
							name: "凯骏配电房#南#Camera02",
							roomName: "KJSub",
						}
					],
					[],
				],
			},
		}, {
			areaId: 4,
			rooms: {
				types: ["监控列表", "门禁列表"],
				details: [
					[],
					[],
				],
			},
		}, {
			areaId: 5,
			rooms: {
				types: ["监控列表", "门禁列表"],
				details: [
					[],
					[],
				],
			},
		}, {
			areaId: 6,
			rooms: {
				types: ["监控列表", "门禁列表"],
				details: [
					[],
					[],
				],
			},
		}],

		// 根据区域获取设备列表(直接配置)
		template: [{
			areaId: 3,
			deviceName: 'CX/ZTR14/',
			devicesList: [{
				name: "主进线柜",
				value: "CX/ZTR14/",
			}, ],
			threeUrl: 'kj'
		}, {
			areaId: 4,
			deviceName: 'AD/AD_total/',
			devicesList: [{
				name: "A1配电柜",
				value: "A1/ZTR1/",
			}, {
				name: "A2配电柜",
				value: "A2/ZTR1/",
			}, ],
			threeUrl: 'A'
		}, {
			areaId: 5,
			deviceName: 'BD/BD_total/',
			devicesList: [{
				name: "B1配电柜",
				value: "B1/ZTR1/",
			}, {
				name: "B2配电柜",
				value: "B2/ZTR1/",
			}, {
				name: "BK配电柜",
				value: "BK/ZTR1/",
			}],
			threeUrl: 'B'
		}, {
			areaId: 6,
			deviceName: 'CD/CD_total/',
			devicesList: [{
				name: "C1配电柜",
				value: "C1/ZTR1/",
			}, {
				name: "C2配电柜",
				value: "C2/ZTR1/",
			}, {
				name: "CK配电柜",
				value: "CK/ZTR1/",
			}],
			threeUrl: 'C'
		}],

		// 园区进线总表(直接配置)
		overViewDeviceName: 'CX/ZTR14/',

		// MQTT数据(在APP.Vue中通过mqtt获取)
		MQTTObj: {},

		// 分合闸数据(在SiteOverView.Vue中通过接口获取)
		CloseAndOpen: [],
	},
	mutations: {
		addMQTTData(state, obj) {
			Vue.set(state.MQTTObj, obj.key, obj.val)
		},
		set_val(state, object) {
			for (let key in object) {
				state[key] = object[key]
			}
		},
		del_val(state, val) {
			state.val = ''
		}
	},
	getters: {
		unbalance: state => deviceName => {

			let ua = isNaN(Number.parseFloat(state.MQTTObj[deviceName + 'Ua'])) ? 0 : Number.parseFloat(state.MQTTObj[deviceName + 'Ua'])
			let ub = isNaN(Number.parseFloat(state.MQTTObj[deviceName + 'Ub'])) ? 0 : Number.parseFloat(state.MQTTObj[deviceName + 'Ub'])
			let uc = isNaN(Number.parseFloat(state.MQTTObj[deviceName + 'Uc'])) ? 0 : Number.parseFloat(state.MQTTObj[deviceName + 'Uc'])

			let average = (ua + ub + uc) / 3
			let max = Math.max(ua, ub, uc)
			let min = Math.min(ua, ub, uc)

			return average === 0 ? 0 : ((max - min) * 100 / average).toFixed(3).replace(/[.]?0+$/, "")
		},

		getRooms: state => id => {
			if (id == -1) {
				return state.surveillance[0].rooms
			} else {
				return state.surveillance.find(item => item.areaId == id).rooms
			}
		},

		getDeviceName: state => id => {
			return state.template.find(item => item.areaId == id).deviceName
		},

		getDevicesList: state => id => {
			return state.template.find(item => item.areaId == id).devicesList
		}, 

		getThreeUrl: state => id => {
			return state.template.find(item => item.areaId == id).threeUrl
		},

		getOverViewDeviceName: state => id => {
			return state.overViewDeviceName
		}
	}
})